export default "__VITE_ASSET__vEMkHTdJ__"